export default {
  common: {
    siteName: "AllChinaBuy Spreadsheet",
    siteTagline: "Trouvailles, guides & ressources",
    disclaimer: "Ressource indépendante — non affiliée à AllChinaBuy",
    nav: {
      home: "Accueil",
      categories: "Catégories",
      guides: "Guides",
      shoppingGuide: "Guide d'achat",
      safety: "Sécurité",
    },
    lang: {
      label: "Langue",
      en: "English",
      fr: "Français",
      da: "Dansk",
      de: "Deutsch",
    },
    buttons: {
      buyNow: "Acheter maintenant",
      mainCta: "AllChinaBuy Spreadsheet",
      explore: "Explorer",
      visitMain: "Visiter le site principal",
      readGuide: "Lire le guide",
      backHome: "Retour à l'accueil",
      learnMore: "En savoir plus",
    },
    categories: {
      shoes: "Chaussures",
      hoodies: "Hoodies/Sweats",
      tshirts: "T-Shirts",
      jackets: "Vestes",
      pants: "Pantalons/Shorts",
      headwear: "Couvre-chefs",
      sets: "Ensembles",
      underwear: "Sous-vêtements/Caleçons",
      jersey: "Maillots",
      accessories: "Accessoires",
      bags: "Sacs",
      belts: "Ceintures",
      perfumes: "Parfums",
      other: "Autres articles",
    },
    footer: {
      about: "AllChinaBuy Spreadsheet est un hub d'information indépendant qui aide les acheteurs à découvrir des ressources organisées, des trouvailles de produits, des guides d'achat, des conseils d'expédition et des informations QC.",
      explore: "Explorer",
      resources: "Ressources",
      home: "Accueil",
      guide: "Guide complet",
      categoriesLabel: "Catégories",
      legal: "Mentions légales",
      privacy: "Confidentialité",
      terms: "Conditions",
      affiliate: "Divulgation d'affiliation",
      copyright: "Tous droits réservés.",
      independent: "Ce site est une ressource indépendante et n'est ni affilié ni approuvé par AllChinaBuy.",
    },
  },
};